<template>
    <div>
        <section class="content-header">
            <h1>
                Уведомления
            </h1>
        </section>

        <section class="content container-fluid alerts">
            <div class="row no-row">
                <div class="col-md-9 col-sm-12 p-0">
                    <div class="row no-row p-0">
                        <div class="col-md-12 mb-4 pl-0" v-for="notification in notifications">
                            <el-card class="box-card">
                                <div class="media mb-1">
                                    <div class="media-left">
                                        <img v-if="notification.status == 0" src="../../assets/status/status-0.svg" class="media-object" style="width:40px">
                                        <img v-if="notification.status == 1" src="../../assets/status/status-1.svg" class="media-object" style="width:40px">
                                        <img v-if="notification.status == 2" src="../../assets/status/status-2.svg" class="media-object" style="width:40px">
                                        <img v-if="notification.status == 3" src="../../assets/status/status-1.svg" class="media-object" style="width:40px">
                                    </div>
                                    <div class="media-body">
                                        <h4 class="media-heading">{{ notification.title }}</h4>
                                        <p class="mb-3" v-html="notification.text" v-linkified></p>
                                        <a v-if="notification.image" :href="notification.image" target="_blank"><img :src="notification.image" class="addon-image mb-3"></a>
                                        <p class="mb-0 time"><i class="el-icon-time"></i> {{ notification.date }}</p>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                        <div class="col-md-12 mb-4 pl-0">
                            <center>
                                <el-button class="mt-5 btn-block" :disabled="allRequests? true: false" @click="scroll()"><i class="el-icon-menu"></i> Загрузить еще</el-button>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="overlay" v-if="loader">
            <div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'notifications',
        data() {
            return {
                acceptModal: false,
                notifications: [],
                loader: 0,
                now: 0,
                allRequests: 0
            }
        },
        methods: {
            loadNotifications() {
                this.loader = 1;
                this.$store.dispatch('customer/loadNotifications', {nowRecords: this.now}).then((response) => {
                    this.loader = 0;
                    if (response.data.data.length < 50) this.allRequests = 1;

                    if (this.now > 0) {
                        if (!response.data.data.length) {
                            this.allRequests = 1;
                            return;
                        }
                        this.notifications = this.notifications.concat(response.data.data);
                    } else {
                        this.notifications = response.data.data;
                    }
                });
            },
            scroll () {
                this.now += 50;
                this.loadNotifications();
            },
        },
        created() {
            this.loadNotifications();
            this.$store.dispatch('customer/acceptNotifications').then(() => {
                this.$store.dispatch('user/checkNotifications');
            });
        }
    }
</script>

<style>
    .alerts .el-table .cell {
        white-space: normal;
    }
    .alerts .el-table b {
        font-weight: 500;
    }
    .media-heading {
        font-weight: 400;
    }
    .media-body {
        font-weight: 200;
    }
    .media-body .time {
        color: rgba(0, 0, 0, 0.33);
    }
    .addon-image {
        max-width: 60%;
        border-radius: 4px;
    }
    .time {
        width: 166px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 400;
    }
    .no-row {
        margin-right: 0px!important;
        margin-left: 0px!important;
    }
    .overlay{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: rgba(255, 255, 255, 0.72);
        height: 100%;
    }
    .overlay>.fa, .overlay-wrapper .overlay>.fa {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -15px;
        margin-top: -15px;
        color: #3498ff;
        font-size: 30px;
    }
</style>
